<div [style]="{'display': 'flex', 'justify-content':'center','align-items': 'center','height': '100vh'}">
  <p-panel (keydown.enter)="login()">
    <ng-template pTemplate="header">
      Login
    </ng-template>

    <ng-template pTemplate="footer">
      <div [style]="{'display': 'flex', 'justify-content':'right'}">
        <p-button label="Login" (click)="login()" />
      </div>
    </ng-template>

    <ng-template pTemplate="content">
      <div class="grid">
        <label class="col-12" for="trfm-customerid">Customer</label>
        <input class="col-12" id="trfm-customerid" pInputText [(ngModel)]="customer" />
      </div>
      <div class="grid">
        <label class="col-12" for="trfm-apiKey">Password</label>
        <input class="col-12" id="trfm-apiKey" type="password" pInputText [(ngModel)]="apiKey" />
      </div>
    </ng-template>
  </p-panel>
</div>